module.exports = "/assets/data/99e1adf9a0940a4ebd5217826225dce3-CH2.data.json";